import React from "react";
import { ToggleSelect, ButtonIcon } from "@loanbossinc/component-library";

import { MaxProceedsDropdown, NOIAdjuster } from "..";

import { RefiAnalysisTypeOptions } from "./constants";
import "./styles.css";

const FilterSection = ({
  selectedNoiAdjustment,
  selectedMaxProceedsFilter,
  setRefiAnalysisType,
  setSelectedNoiAdjustment,
  setSelectedMaxProceedsFilter,
  handleRefreshClicked
}) => (
  <div className="refi-proceeds-analysis-filter-section-wrapper">
    <div className="refi-proceeds-analysis-filter-section-noi-and-ltv-wrapper">
      <div className="refi-proceeds-analysis-filter-section-noi-wrapper">
        <span>NOI Adjustment:</span>
        <span><NOIAdjuster selectedNoiAdjustment={selectedNoiAdjustment} onChange={val => setSelectedNoiAdjustment(val)} /></span>
      </div>
      <div className="refi-proceeds-analysis-filter-section-ltv-wrapper">
        <span>Filter by LTV:</span>
        <span><MaxProceedsDropdown selectedFilter={selectedMaxProceedsFilter} onChange={e => setSelectedMaxProceedsFilter(e.target.value)} /></span>
      </div>
    </div>
    <div className="refi-proceeds-analysis-filter-section-refi-or-cashout-refresh-wrapper">
      {/* TODO: Style the ToggleSelect and parent div height and also create ability to specify selected amount */}
      <div>
        <ToggleSelect
          options={RefiAnalysisTypeOptions}
          onChange={selection => {
            if (selection?.name) {
              setRefiAnalysisType(selection?.name);
            }
          }}
          requireSelection
        />
      </div>
      <ButtonIcon onClick={handleRefreshClicked} iconName="refresh" />
    </div>
  </div>
);

export default FilterSection;
